"use client";
import React from 'react';
import { motion } from 'framer-motion';

const steps = ['Understand', 'Map', 'Optimise', 'Build', 'Measure'];

export default function LocalSEOApproach() {
    return (
        <section className="relative overflow-hidden py-16 md:py-28 px-4 md:px-16 lg:px-24" style={{ background: '#0f0f0f' }}>
            <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, rgba(206,255,26,1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="max-w-[1000px] mx-auto flex flex-col gap-14 relative z-10">

                {/* Header */}
                <div className="flex flex-col items-center gap-4 text-center">
                    <motion.span initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
                        className="text-xs font-bold tracking-[0.25em] uppercase"
                        style={{ color: 'rgba(206,255,26,0.6)', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}>
                        How We Work
                    </motion.span>
                    <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.1 }}
                        className="text-2xl md:text-5xl font-bold tracking-tight leading-tight"
                        style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#ffffff' }}>
                        Our Approach to <span style={{ color: '#ceff1a' }}>Local SEO</span>
                    </motion.h2>
                </div>

                {/* Step flow */}
                <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3">
                    {steps.map((step, i) => (
                        <React.Fragment key={i}>
                            <motion.div
                                initial={{ opacity: 0, y: 16 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.4, delay: i * 0.08 }}
                                className="px-5 py-3 md:px-7 md:py-4 rounded-full"
                                style={{ background: 'rgba(206,255,26,0.06)', border: '1px solid rgba(206,255,26,0.25)' }}
                            >
                                <span
                                    className="text-sm md:text-base font-bold uppercase tracking-wide"
                                    style={{ color: '#ceff1a', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                                >
                                    {step}
                                </span>
                            </motion.div>
                            {i < steps.length - 1 && (
                                <motion.svg
                                    initial={{ opacity: 0 }}
                                    whileInView={{ opacity: 1 }}
                                    viewport={{ once: true }}
                                    transition={{ duration: 0.4, delay: i * 0.08 + 0.05 }}
                                    width="20" height="20" viewBox="0 0 20 20" fill="none"
                                >
                                    <path d="M3 10h13M11 5l5 5-5 5" stroke="rgba(255,255,255,0.3)" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                                </motion.svg>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* Description */}
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col gap-4 max-w-2xl mx-auto text-center"
                >
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        First, we understand your business, customers and service areas.
                    </p>
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        Then we map local search intent, optimise your website and Business Profile, strengthen local relevance and monitor the visibility and actions that matter.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
